<div class="exception-body">

    <div class="exception-topbar">
        <a href="#" class="logo">
            <img src="assets/layout/images/logo-new.png" alt="california-layout"/>
        </a>
    </div>


    <div class="exception-panel">
        <h1 class="exception-summary">Acceso denegado</h1>
        <p class="exception-detail">
            Vaya, parece que no tienes las llaves de este piso<br>
        </p>
        <div>
            <button type="button" pButton label="Ir al inicio" [routerLink]="['/']"></button>
        </div>
    </div>
</div>
